import React, { memo, useState } from "react";
import { Link } from "react-router-dom";
import cx from "classnames";

export const SubMenu = memo((props) => {
    const { code } = props;
    const [ tapType, setTapType ] = useState(0);

    return (
        <div className="top-roundtab-contain">
            <ul>
                {SUBS.map((m, i) => (
                    <li key={i} style={{width:'50%'}}>
                        <Link to={m.url} className={cx({ on: code === m.code })}>
                            {m.label}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
});

export const SUBS = [
    { url: "/sm/rcntDiet", code: "rcnt", label: "최근식단" },
    { url: "#", code: "hist", label: "식단이력" },
];